// extracted by mini-css-extract-plugin
export default {"inputLabel":"FeatureLookupModal_inputLabel__jWuk7"};